import React, { useState } from 'react';
import { ArrowLeft, Plus } from 'lucide-react';
import SavedRoadmapsList from './SavedRoadmapsList';

const RoadmapManager = ({ onBack, onLoadRoadmap, onCreateNew }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-violet-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-8">
        {/* Header */}
        <div className="text-center mb-8">
          {/* Back Button */}
          <div className="flex justify-center mb-4">
            <button
              className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 hover:text-blue-600 hover:border-blue-300 font-medium transition-all duration-200 shadow-sm hover:shadow-md"
              onClick={onBack}
              type="button"
            >
              <ArrowLeft className="w-4 h-4" />
              Voltar
            </button>
          </div>
          
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-purple-100 rounded-full mb-4">
            <svg className="w-4 h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
            </svg>
            <span className="text-purple-800 font-medium text-sm">Roadmaps Salvos</span>
          </div>
          
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
            Gerencie seus Roadmaps
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Carregue, edite ou duplique seus roadmaps salvos
          </p>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            {/* Action Bar */}
            <div className="bg-gray-50 border-b border-gray-200 px-6 py-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">
                  Seus Roadmaps
                </h3>
                <button
                  onClick={onCreateNew}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium transition-colors shadow-sm"
                >
                  <Plus className="w-4 h-4" />
                  Criar Novo
                </button>
              </div>
            </div>

            {/* Roadmaps List */}
            <div className="p-6">
              <SavedRoadmapsList
                onLoadRoadmap={(roadmap) => {
                  onLoadRoadmap(roadmap);
                  // Não chama onBack() aqui para não resetar o roadmapMode
                  // O handleLoadRoadmap já vai definir o modo correto para edição
                }}
                currentRoadmapId={null}
                onRoadmapDeleted={() => {
                  // Callback quando um roadmap é excluído
                  if (process.env.NODE_ENV === 'development') {
                    console.log('Roadmap excluído');
                  }
                }}
              />
            </div>
          </div>
        </div>

        {/* Helper Text */}
        <div className="text-center mt-8">
          <p className="text-gray-500 text-sm">
            💡 Dica: Use a opção "Editar" para modificar seus roadmaps existentes
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoadmapManager;
